import breakpoints from "@constants/breakpoints"
import colors from "@constants/colors"
import { body14Styles, h5Styles } from "@constants/typography"
import { DesktopOnly, MobileAndTabletOnly } from "@utils/MediaQuery"
import React from "react"
import styled from "styled-components"

import Block, { BlockProps } from "./Block"
import { BreadcrumbButton, Headers } from "./common"

const Container = styled.div`
  height: 100%;
  overflow: hidden;

  @media ${breakpoints.laptop} {
    padding: 200px calc(0.5 / 12 * 100vw) 0;
  }
`

const Header = styled.div`
  ${h5Styles}
  padding-bottom: 32px;
`

const Deal = styled.div`
  ${body14Styles}
  align-items: center;
  display: flex;
  height: 85px;
  padding: 0 20px;
  border-bottom: solid 1px ${colors.dividerLineGray};
  background-color: ${colors.dealGray};
  color: ${colors.brandOrange};
`

const Products = styled.div`
  display: grid;
  grid-auto-rows: min-content;
  grid-template-columns: repeat(1, 1fr);
  row-gap: 16px;
  height: calc(100% - 85px - 72px);
  padding: 36px 20px;
  overflow: hidden;
  overflow-y: auto;

  @media ${breakpoints.laptop} {
    row-gap: 24px;
    column-gap: 24px;
    height: calc(100% - 64px);
    padding: 0;
    padding-bottom: 48px;
  }

  @media ${breakpoints.desktop} {
    grid-template-columns: repeat(2, 1fr);
  }
`

interface SelectProductProps {
  deal: string
  header: string
  onRequestClose: () => void
  products: Array<BlockProps>
}

const SelectProduct: React.FC<SelectProductProps> = ({
  deal,
  header,
  onRequestClose,
  products,
}) => {
  return (
    <Container>
      <MobileAndTabletOnly>
        <Headers>
          <BreadcrumbButton label={header || ""} onClick={onRequestClose} />
        </Headers>
        <Deal>{deal}</Deal>
      </MobileAndTabletOnly>
      <DesktopOnly>
        <Header>{header}</Header>
      </DesktopOnly>
      <Products>
        {products.map((product, i) => (
          <Block key={`${i}: ${product.productName}`} {...product} />
        ))}
      </Products>
    </Container>
  )
}

export default SelectProduct
